module.exports = __webpack_public_path__ + "img/grating-ore.fe715ad0.png";